import React from 'react';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { Dropdown } from 'react-bootstrap';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Container } from '../../../../styles/container.style';
import { Category } from '../../../../models/category.model';
import { Link, useNavigate } from 'react-router-dom';
import { CategoryDA } from '../../../../services/category.service';
import { ServiceDA } from '../../../../services/service.service';
import { ProductDA } from '../../../../services/product.service';
import { Message } from '../../../../models/message.model';
import { Error } from '../../../../models/error.model';
import { getError, getMessage } from '../../../../languages/translations/response';
import { categorySelected } from '../../../../scripts/list.selected.item.script';
import { modalShow } from '../../../../tools/modal.tool';

export interface AppInventoryListHeaderProps {
  inventory: string,
  filter: {search: string, options: any},
  checked: {count: number, list: string[]},
  loadInventory: Function
};

let errorResponse: Error, messageResponse: Message;

const AppInventoryListHeader: React.FunctionComponent<AppInventoryListHeaderProps> = ({inventory, filter, checked, loadInventory}) => {
  const {companyForUser, categoriesForCompany, loadServicesForCompany, loadProductsForCompany, setCategoriesForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()
  const navigate = useNavigate()

  const submitDeleteList = () => {
    if (companyForUser && categoriesForCompany && inventory === 'category') {
      Swal.fire({
        title: lang.labels.youWantToDeleteSelectedCategories,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel,
        customClass: {confirmButton:'btn btn-primary', cancelButton:'btn btn-secondary'}
      }).then(async (result) => {
        if (result.isConfirmed) {
          await CategoryDA.deleteCategories(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                setCategoriesForCompany(categoriesForCompany.filter((temp) => !checked.list.includes(temp.id)))

                Swal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1800
                } as SweetAlertOptions)
              })
            } else {
              errorResponse = response.data

              Swal.fire({
                title: getError(errorResponse.code, lang.code),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                buttonsStyling: !1,
                confirmButtonText: lang.labels.okGotIt,
                customClass: {confirmButton: 'btn btn-primary'}
              } as SweetAlertOptions)
            }
          }).catch( (error) => {
            console.error(error)
            navigate('/error')
          })
        }
      })
    }
    if (companyForUser && inventory === 'service') {
      Swal.fire({
        title: lang.labels.youWantDeleteSelectedServices,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel,
        customClass: {confirmButton:'btn btn-primary', cancelButton:'btn btn-secondary'}
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ServiceDA.deleteServices(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                loadServicesForCompany(companyForUser.id)

                Swal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1800
                } as SweetAlertOptions)
              })
            } else {
              errorResponse = response.data

              Swal.fire({
                title: getError(errorResponse.code, lang.code),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                buttonsStyling: !1,
                confirmButtonText: lang.labels.okGotIt,
                customClass: {confirmButton: 'btn btn-primary'}
              } as SweetAlertOptions)
            }
          }).catch( (error) => {
            console.error(error)
            navigate('/error')
          })
        }
      })
    }
    if (companyForUser && inventory === 'product') {
      Swal.fire({
        title: lang.labels.youWantDeleteSelectedProducts,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel,
        customClass: {confirmButton:'btn btn-primary', cancelButton:'btn btn-secondary'}
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ProductDA.deleteProducts(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                loadProductsForCompany(companyForUser.id)

                Swal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1800
                } as SweetAlertOptions)
              })
            } else {
              errorResponse = response.data

              Swal.fire({
                title: getError(errorResponse.code, lang.code),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                buttonsStyling: !1,
                confirmButtonText: lang.labels.okGotIt,
                customClass: {confirmButton: 'btn btn-primary'}
              } as SweetAlertOptions)
            }
          }).catch( (error) => {
            console.error(error)
            navigate('/error')
          })
        }
      })
    }
  }

  const handleChangeSearch = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    if (companyForUser) {
      filter.search = event.target.value
      filter.options.category = ''
      filter.options.sort_field= ''
      filter.options.sort_mode = ''
      loadInventory(companyForUser.id, () => {})
    }
  }

  const executeServiceCategory = (item: string) => {
    if (companyForUser) {
      filter.search = ''
      filter.options.category = item
      filter.options.sort_field= ''
      filter.options.sort_mode = ''
      loadInventory(companyForUser.id, () => {})
    }
  }

  const executeShowModalCategoryCreate = () => {
    modalShow('modal-category-create')
  }

  function categories(): Category[] {
    switch (inventory) {
      case 'service':
        return categoriesForCompany?.filter((item) => (item.services.length > 0)) || []
      case 'product':
        return categoriesForCompany?.filter((item) => (item.products.length > 0)) || []
      default:
        return []
    }
  }

  return (
    <div className="card-header">
      <div className="card-title">
        <div className="d-flex align-items-center position-relative">
          <span className="svg-icon svg-icon-1 position-absolute ms-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
              <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
            </svg>
          </span>
          <input className="form-control form-control-solid w-350px ps-14" type="text" autoComplete="off" placeholder={lang.labels[`search${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}` as keyof typeof lang.labels]} value={filter.search} onChange={handleChangeSearch} />
        </div>
      </div>
      <div className="card-toolbar">
        <Container property={(checked.count === 0).toString()}>
          <div className="d-flex justify-content-end align-items-center">
            { categoriesForCompany && inventory !== "category" &&
              <Dropdown>
                <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-200px p-0 me-2">
                  <span className="selection">
                    <span className="select2-selection select2-selection--single form-select form-select-solid">
                      <span className="select2-selection__rendered" role="textbox">
                        {categorySelected(lang, categoriesForCompany, filter.options.category)}
                      </span>
                    </span>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100" align="end">
                  <span className="select2-dropdown select2-dropdown--below">
                    <span className="select2-results">
                      <ul className="select2-results__options" role="listbox">
                        <li className={`select2-results__option select2-results__option--selectable ${filter.options.category.length === 0 && "select2-results__option--selected"}`} role="option" aria-selected={filter.options.category.length === 0}>
                          <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => executeServiceCategory("")}>{lang.labels.all}</Dropdown.Item>
                        </li>
                        { categories().map (( (item, index) => { return (
                          <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === filter.options.category && "select2-results__option--selected"}`} role="option" aria-selected={item.id === filter.options.category}>
                            <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => executeServiceCategory(item.id)}>{item.display_name}</Dropdown.Item>
                          </li>
                        )}))}
                      </ul>
                    </span>
                  </span>
                </Dropdown.Menu>
              </Dropdown>
            }
            { inventory === "category" &&
              <button className="btn btn-primary" type="button" onClick={executeShowModalCategoryCreate}>
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels.addCategory}
                </div>
              </button>
            }
            { inventory !== "category" &&
              <Link to={"/app/inventory/" + inventory + "/create"} className="btn btn-primary">
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels[`add${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}` as keyof typeof lang.labels]}
                </div>
              </Link>
            }
          </div>
        </Container>
        <Container property={(checked.count > 0).toString()}>
          <div className="d-flex justify-content-end align-items-center">
            <div className="fw-bolder me-5">
              <span className="me-2">{checked.count}</span>
              {lang.labels.selected}
            </div>
            <button className="btn btn-danger" type="button" onClick={submitDeleteList}>{lang.labels.deleteSelected}</button>
          </div>
        </Container>
      </div>
    </div>
  )
};

export default AppInventoryListHeader;
